import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=a0fc6836&"
import script from "./ImageText.vue?vue&type=script&lang=js&"
export * from "./ImageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports